export enum LogoType {
  PROFILE_PICTURE = "PROFILE_PICTURE",
  FIRM_LOGO = "FIRM_LOGO",
}


export enum SaveLogoMessage {
  PROFILE_PICTURE = 'Profile picture uploaded successfully',
  FIRM_LOGO = 'Firm logo uploaded successfully',
  PROFILE_BGCOLOR = 'Profile background color updated successfully',
}

export enum RemoveLogoMessage {
  PROFILE_PICTURE = 'Profile picture removed successfully',
  FIRM_LOGO = 'Firm logo removed successfully',
  PROFILE_BGCOLOR = 'Profile background color removed successfully',
}